import type { FractionIsh, NumberIsh } from 'bi-fraction';
import { Fraction } from 'bi-fraction';
import type { useTranslations } from 'next-intl';

export const validateNotEmpty = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (!value.trim()) {
    return t('card.required');
  }
};

export const validateNotZero = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (new Fraction(value).eq(0)) {
    return t('card.cannot be zero');
  }
};

export const validateNumberFormat = ({
  t,
  value,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
}) => {
  if (!/^\d+$/.test(value) && !/^\d+\.\d+$/.test(value)) {
    return t('card.invalid value');
  }
};

export const validateMaxValue = ({
  t,
  value,
  maxValue,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  maxValue?: FractionIsh;
}) => {
  if (maxValue && new Fraction(value).gt(maxValue)) {
    return t('card.insufficient balance');
  }
};

export const validateMinValue = ({
  t,
  value,
  minValue,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  minValue?: NumberIsh;
}) => {
  if (minValue && new Fraction(value).lt(minValue)) {
    return t('card.must be at least {min}', {
      min: String(minValue),
    });
  }
};

export const validateMaxDecimals = ({
  t,
  value,
  maxDecimals,
}: {
  t: ReturnType<typeof useTranslations<string>>;
  value: string;
  maxDecimals: number;
}) => {
  const decimalPart = value.split('.')[1];
  if (decimalPart && decimalPart.length > maxDecimals) {
    return t('card.maximum number of decimals is {decimals}', {
      decimals: maxDecimals,
    });
  }
};
